import FullPageLoader from 'components/loader/FullPageLoader';
import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';

/**
 * @component LayoutBody
 * @description Componente que encapsula el cuerpo principal del layout del examen EPST.
 * Muestra un loader de pantalla completa mientras se cargan los datos y, opcionalmente, una barra de progreso.
 *
 * @param {Object} props - Props del componente
 * @param {boolean} props.progressBar - Determina si se debe mostrar la barra de progreso superior.
 * @param {number} props.step - Paso actual del examen (utilizado para calcular el progreso).
 * @param {boolean} props.loading - Estado de carga. Si es true, se muestra un loader en pantalla completa.
 * @param {Function} props.renderStepComponent - Función que devuelve el componente correspondiente al paso actual.
 *
 * @returns {JSX.Element}
 *
 * @example
 * <LayoutBody
 *   progressBar={true}
 *   step={4}
 *   loading={isLoading}
 *   renderStepComponent={renderContent}
 * />
 */
const LayoutBody = ({ progressBar, step, loading, renderStepComponent }) => (
	<>
		{progressBar && <ProgressBar now={step * 9.09} style={{ height: 2 }} />}
		<Card.Body className="fw-normal px-md-6 py-4">
			{loading ? (
				<FullPageLoader loading={loading} />
			) : (
				renderStepComponent()
			)}
		</Card.Body>
	</>
);

export default LayoutBody;